import * as Yup from "yup";

export default function validation_participant_password(field, acc, editMode) {
  const { field_name } = field;

  // No se aplica ninguna validación
  return {
    [field_name]: Yup.string(),
    ...acc,
  };
}
